import { ResultadoBusca, ParametrosDoFind } from './../../common/types/Busca'
import axios from '@/plugins/axios'
import { analytics } from '@/firebase'
import { Pagina } from 'common/types/paginacao'

class SearchService {
	async find(parametros: ParametrosDoFind = {}) {
		try {
			analytics.logEvent('search', {
				search_term: parametros.search,
			})
			const result = await axios.get<Pagina<ResultadoBusca>>('/search', {
				params: parametros,
			})
			return result.data
		} catch (error) {
			throw error
		}
	}
}

export default new SearchService()
